export default "__VITE_ASSET__BFshLVy2__"